{
  "title": "Campanion Staff Access",
  "description": "All hired staff automatically have access to standard Staff Engagement features. Use the toggles below to grant or revoke access to individual add-on features on a per-staff basis.",
  "experimentalNotice": {
    "title": "Experimental feature — not yet supported",
    "body": "Campanion Staff Access is an experimental, early-access feature that we don't currently offer support for. It may change at any time and could potentially be removed at the end of summer if it doesn't meet client needs. Select \"How it works\" above to watch a walkthrough.",
    "contactNote": "Feel free to contact your CSM if you see issues and/or have ideas regarding this feature. We highly value your feedback."
  },
  "video": {
    "buttonText": "How it works",
    "modalTitle": "How Campanion Staff Access works"
  },
  "filters": {
    "firstYearOnly": "First-year staff only"
  },
  "bulkTurnOff": {
    "buttonText": "Turn all off for {camp}",
    "confirmTitle": "Turn off Name That Camper for everyone?",
    "confirmDescription": "This revokes Name That Camper access for every staff member at {camp}. Are you really sure? You'll have to manually re-add every user if you do this.",
    "confirmButtonText": "Yes, turn all off",
    "successToast": "Turned off Name That Camper for all staff.",
    "errorToast": "Couldn't turn off {count} staff member(s). Please try again."
  },
  "columns": {
    "name": "Name",
    "nameThatCamper": "Name That Camper"
  },
  "errors": {
    "loadFailed": "We couldn't load staff right now. Please refresh the page and try again.",
    "accessLoadFailed": "We couldn't load current Name That Camper access — toggles may not reflect saved settings. Please refresh the page.",
    "toggleFailed": "We couldn't update Name That Camper access. Please try again."
  }
}
